export default __webpack_public_path__ + "static/media/logo.71cced73.svg";